import { baseApiRoutes } from '../../core/config/apiRoutes';

export const apiRoutes = {
  ...baseApiRoutes,
  demo: {
    formSubmit: 'demo/form-submit',
    testOptions: 'demo/test-options',
    projectOptions: 'demo/project-options',
    statusOptions: 'demo/status-options',
    employeesOptions: 'demo/employee-options',
    typeOptions: 'demo/type-options',
    priorityOptions: 'demo/priority-options',
    taskInfo: 'demo/task-info',
    updateForm: 'demo/update-form',
    getKanban: 'demo/kanban',
    getCommentsCount: 'demo/comments-count',
    updateKanbanPosition: 'demo/kanban-position',
    deleteAction: 'demo/delete',
  },
};
